import React from 'react';

const CrossIcon = (props) => {
  return (
    <svg {...props} height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.00002 1L1 9.00002M1.00003 1L9.00005 9.00002'
        stroke={props.fill}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default CrossIcon;
